import { ArrowRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em] transition-all duration-300 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-aqua-bright focus-visible:ring-offset-2 focus-visible:ring-offset-navy-950";

export const PrimaryButton = ({ children, className = "", ...props }) => (
  <button
    type="button"
    className={`${base} border border-aqua/70 bg-aqua/10 px-7 py-4 text-offwhite hover:border-aqua-bright hover:bg-aqua/20 hover:shadow-[0_0_28px_-10px_hsl(var(--aqua-bright))] active:translate-y-px ${className}`}
    {...props}
  >
    {children}
    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
  </button>
);

export const GhostButton = ({ children, className = "", ...props }) => (
  <button
    type="button"
    className={`${base} border border-border px-7 py-4 text-mist hover:border-mist/60 hover:text-offwhite active:translate-y-px ${className}`}
    {...props}
  >
    {children}
  </button>
);
